export default __webpack_public_path__ + "static/media/footerInstagramIcon.7b8f1a2e.svg";